import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Row, Button, Form, Typography } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { Creators as authActions } from '../../appRedux/ducks/auth/auth'
import { Creators as AlertActions } from '../../appRedux/ducks/alert'
import logo from '../../assets/images/Logo@2x.png'
import mock from '../../assets/images/Mock@2x.png'
import buttonPlayStore from '../../assets/images/playStore.png'
import playStore from '../../assets/images/playStoreQrCode.png'
import CustomInput from '../../components/CustomInput/customInput'
import * as api from '../../services/api'
import { request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import './styles.css'

const Login = function ({ history }) {
  const searchParams = new URLSearchParams(window.location.search)
  const parsed = Object.fromEntries(searchParams.entries())
  const dispatch = useDispatch()

  const auth = useSelector((state) => state.auth.auth)

  useEffect(() => {
    if (parsed.expired) {
      dispatch(AlertActions.openAlert('Token expirou'))
    }
  }, [parsed])

  useEffect(() => {
    if (auth.token) {
      history.push('/dashboard')
    } else {
      history.replace('/')
    }
  }, [])

  const form = {
    initialValues: {},
    yupValidation: yup.object().shape({
      email: yup
        .string()
        .min(1, getMessage('minLenght', 'E-mail', '4'))
        .email(getMessage('isInvalidEmail'))
        .required(getMessage('isRequired', 'E-mail')),
      password: yup
        .string()
        .min(1, getMessage('minLenght', 'Senha', '4'))
        .required(getMessage('isRequired', 'Senha'))
    }),
    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      try {
        const response = await request(
          api.auth({
            userLogin: values.email,
            userPassword: values.password
          })
        )
        dispatch(
          authActions.success({
            ...response.user
          })
        )
        if (response) {
          const appStorage = window.localStorage
          appStorage.setItem('userId', response.user && response.user.id)
          appStorage.setItem('entitlements', response.user && response.user.entitlements)
          history.push('/dashboard')
        }
      } catch (error) {
        console.tron.log('Auth error', error)
      }
    }
  }

  function renderButtons(submitForm) {
    return (
      <div className="containerFormActions">
        <Button
          type="link"
          className="buttonArea"
          onClick={() => {
            console.tron.log('history', history)
            history.push('password-recovery')
          }}
          style={{ padding: 0 }}
        >
          <span className="textColorWhite">
            <u>{getMessage('app.userAuth.forgotPassword')}</u>
          </span>
        </Button>
        <Button className="btEnter" type="primary" onClick={() => submitForm()}>
          {getMessage('app.userAuth.signIn')}
        </Button>
      </div>
    )
  }

  function renderFormik() {
    return (
      <Formik
        enableReinitialize
        validationSchema={form.yupValidation}
        initialValues={form.initialValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          return (
            <Form className="loginForm" layout="vertical" onSubmit={handleSubmit}>
              <Row>
                <Typography className="qrCodeText label">{getMessage('bayerUser')}</Typography>
                <CustomInput
                  customNameField="emptyString"
                  placeholder="E-mail"
                  field="email"
                  errors={errors}
                  setFieldValue={setFieldValue}
                  value={values}
                  handleBlur={handleBlur}
                  type="email"
                />
                <Typography className="qrCodeText label">{getMessage('bayerPassword')}</Typography>
                <CustomInput
                  placeholder="Senha"
                  type="password"
                  customNameField="emptyString"
                  field="password"
                  errors={errors}
                  setFieldValue={setFieldValue}
                  value={values}
                  handleBlur={handleBlur}
                />
              </Row>
              {renderButtons(submitForm)}
              {/* <Checkbox className="saveCredentials" value={saveCredential} onChange={() => setSaveCredentials(!saveCredential)} >{getMessage('credentials')}</Checkbox> */}
            </Form>
          )
        }}
      </Formik>
    )
  }

  return (
    <div className="mainlyContainer">
      <div className="container" style={{ height: -10 }}>
        <div className="coberturas1">
          <div className="mockContainer">
            <img src={mock} alt="Soyshare" className="mock" />
            <p className="desciptionText">
              O Soyshare também está <br /> disponível para dispositivos <br /> mobile
            </p>
          </div>
          <div>
            <p className="mockContainer qrCodeText" style={{ marginTop: '-10%' }}>
              Use o QR code para baixar
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
            <img src={playStore} alt="Soyshare" style={{ width: '20%' }} />
            <img src={buttonPlayStore} alt="Soyshare" style={{ marginTop: 2, width: '20%' }} />
          </div>
        </div>
        <div className="coberturas2">
          <img src={logo} alt="Soyshare" className="logo" />
          {renderFormik()}
        </div>
      </div>
    </div>
  )
}

export default Login
